import React from 'react';

export const LiveMetrics = ({ metrics }) => (
  <div className="grid grid-cols-6 gap-4 mb-6">
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-white">{metrics.activeRides}</div>
      <div className="text-xs text-gray-400">Active Rides</div>
    </div>
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-white">{metrics.onlineDrivers}</div>
      <div className="text-xs text-gray-400">Online Drivers</div>
    </div>
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-yellow-400">{metrics.pendingDispatches}</div>
      <div className="text-xs text-gray-400">Pending Dispatches</div>
    </div>
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-red-400">{metrics.failedDispatches}</div>
      <div className="text-xs text-gray-400">Failed Dispatches</div>
    </div>
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-green-400">R{metrics.todayRevenue.toFixed(2)}</div>
      <div className="text-xs text-gray-400">Today Revenue</div>
    </div>
    <div className="bg-gray-800 rounded-lg p-4">
      <div className="text-2xl font-bold text-white">{metrics.systemHealth}%</div>
      <div className="text-xs text-gray-400">System Health</div>
    </div>
  </div>
);
